import React, { useEffect, useState } from 'react'
import { Button, DateRangePicker, Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react'
import { IconChartHistogram, IconGraph, IconSearch, IconSoup, IconTrash } from '@tabler/icons-react'
import authQueries from '../../queries/authQueries'
import Empty from '../../components/Empty'
import DrawerComponent from '../../components/DrawerComponent'
import ChangePassword from './ChangePassword'
import { snackbarToast } from '../../components/SnackbarToast'
import Loader from '../../components/Loader'
import StatusType from '../../components/StatusType'
import { useDispatch, useSelector } from 'react-redux'
import PaginationComponent from '../../components/PaginationComponent'
import { useApi } from '../../utils/ApiProvider'
import dropdownQueries from '../../queries/dropdownQueries'
import { RouteConstant } from '../../routes/RouteConstant'
import { useNavigate } from 'react-router-dom'
import { setUser } from '../../redux/reducers/userReducers'
import TooltipContainer from '../../components/TooltipContainer'
import ConfirmationModal from '../../components/ConfirmationModal'
import { resetPage } from '../../redux/reducers/paginationReducers'
import statusQueries from '../../queries/statusQueries'
import moment from 'moment'

const UserList = () => {

    const navigate = useNavigate()

    const [result, setResult] = useState([])
    const [dropdownResult, setDropdownResult] = useState([])

    const page = useSelector((state)=> state.pagination.page)
    const size = useSelector((state)=> state.pagination.size)

    const today = moment().format('YYYY-MM-DD')
    const [date, setDate] = useState(today)

    const { apiData, setApiDataAndNotify } = useApi()

    const dispatch = useDispatch()

    const [search, setSearch] = useState('')
    const [department, setDepartment] = useState(null)

    const getData = authQueries.useUserList(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }
        }
    )

    useEffect(() => {
        getData.mutateAsync({search, department, page, size})
    }, [search, department, page, size, apiData]);  
    
    const dropdown = dropdownQueries.useGetAllGroup(
        (res)=>{
            if(res?.success){
                setDropdownResult(res)
            }
        }
    )

    useEffect(() => {
        dropdown.mutateAsync()
    }, []);

    const inputCreateFields = [
        {
            name: 'emp_id',
            type: 'text',
            label: 'Employee Code',
            placeholder: 'Employee Code',
            required: true
        },
        {
            name: 'name',
            type: 'text',
            label: 'Name',
            placeholder: 'Name',
            required: true
        },
        {
            name: 'email',
            type: 'email',
            label: 'Email',
            placeholder: 'Email',
            required: true,
        },
        {
            name: 'password',
            type: 'password',
            label: 'Password',
            placeholder: 'Password',
            required: true,
            min: 6,
            max: 32
        },
        {
            name: 'mobile',
            type: 'number',
            label: 'Mobile No.',
            placeholder: 'Mobile No.',
            required: false
        },
        {
            name: 'dept_id',
            type: 'select',
            label: 'Department',
            placeholder: 'Department',
            required: true,
            options: dropdownResult?.group
        }
    ]    
    
    const inputUpdateFields = [
        {
            name: 'emp_id',
            type: 'text',
            label: 'Employee Code',
            placeholder: 'Employee Code',
            required: true,
            defaultValue: "SNPL"
        },
        {
            name: 'name',
            type: 'text',
            label: 'Name',
            placeholder: 'Name',
            required: true
        },
        {
            name: 'email',
            type: 'email',
            label: 'Email',
            placeholder: 'Email',
            required: true,
        },
        {
            name: 'mobile',
            type: 'number',
            label: 'Mobile No.',
            placeholder: 'Mobile No.',
            required: false
        },
        {
            name: 'dept_id',
            type: 'select',
            label: 'Department',
            placeholder: 'Department',
            required: true,
            options: dropdownResult?.group
        }
    ]
    
    const changePasswordInput = [
        {
            name: 'password',
            type: 'password',
            label: 'Password',
            placeholder: 'Password',
            required: true
        },
    ]
    
    
    const create = authQueries.useCreateUser(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
                snackbarToast('User Created Successfully', 'success')
            }
            if(!res?.success){
                console.log(res)
                if(res?.error?.length === 0){
                    snackbarToast(res?.message, 'error')
                    return
                }

                const errors = res?.error?.map((data) => {
                    if (data.email) {
                        return 'Email already exists';
                    }
                    return null;
                }).filter(Boolean);
                
                errors?.forEach((data) => snackbarToast(data, 'error'));
                
            }
        }
    )

    const update = authQueries.useUpdateUser(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
                snackbarToast('User Updated Successfully', 'success')
            }
            if(!res?.success){
                if(res?.errors?.length === 0){
                    snackbarToast(res?.message, 'error')
                    return
                }

                const errors = res?.error?.map((data) => {
                    if (data.email) {
                        return 'Email already exists';
                    }
                    return null;
                }).filter(Boolean);
                
                errors?.forEach((data) => snackbarToast(data, 'error'));
                
            }
        }
    )

    const changePassword = authQueries.useChangePassword(
        (res)=>{
            if(res?.success){
                snackbarToast('Password Changed Successfully', 'success')
            }
        }
    )
    
    const handleNavigate = (user) => {
        navigate(RouteConstant.STATUSHISTORY)
        dispatch(setUser(user))
    }

    const deleteUser = authQueries.useDeleteUser(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
                snackbarToast('User Deleted Successfully', 'success')
            }
        }
    )

    const handleDelete =(data)=>{
        deleteUser.mutateAsync(data?.id)
    }

    const handleSearch = (e) => {
        setSearch(e.target.value)
        dispatch(resetPage())
    }

    const handleDepartmentFilter = (e) => {
        setDepartment(e.target.value)
        dispatch(resetPage())
    }


    const workStatusCreate = statusQueries.useTodayWorkStatusCreate(
        (res) => {
          if(res?.success) {
            setApiDataAndNotify(new Date());
          }
        }
    );

    const handleAddLunch = (user) => {
        workStatusCreate.mutateAsync({
            lunch_status: "YES",
            work_status: "OFFICE",
            user_id: user?.id,
            date
        });
    }

  return (

    <div className='card-shadow m-4 max-[768px]:m-2 bg-white rounded-[10px]'>

        <div className='flex justify-between max-[934px]:flex-col items-center p-6 gap-y-3'>
            <div>
                <p className='text-[13px] text-[#6D6B77] font-medium'>Showing {result?.totalItems} entries</p>
            </div>
            <div className='flex gap-2 max-[799px]:flex-col max-[799px]:w-full'>
                <select onChange={handleDepartmentFilter} className='w-[200px] max-[799px]:w-full h-[40px] border rounded-[7px] px-3 mt-[1px] text-[13px]'>
                    <option value="">Select Department</option>
                    {
                        dropdownResult?.group?.map((opt, index) =>(
                            <option key={index} value={opt?.id}>{opt?.name}</option>
                        ))
                    }
                </select>
                <div className='relative'>
                    <input onChange={handleSearch} placeholder='Type to search...' className='w-[300px] max-[799px]:w-full h-[40px] border rounded-[7px] pl-10 pr-3 mt-[1px] text-[13px]' />
                    <IconSearch className='absolute top-[12px] left-4 text-secondary' size={16} />
                </div>
                <DrawerComponent entityForm={create} inputFields={inputCreateFields} btnName={'Add User'} header={'Add User'} />
            </div>
        </div>

        {
            getData?.isLoading ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div className='px-6 overflow-x-auto'>
                {
                    result?.totalItems > 0 ?
                        <table className='table w-full'>
                            <thead>
                                <tr className='table-row'>
                                    <th>Sl No.</th>
                                    <th>Emp Code</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Department</th>
                                    <th className='!text-center min-w-[200px]'>Work Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {result?.items?.map((row, index) => {
                                    const findStatus = row?.work_statuses[0]?.work_status
                                    const status = StatusType.find((status) => status.value === findStatus)
                                    return(
                                        <tr key={index} className='table-row'>
                                            <td>{result?.currentPage * 10 + index + 1}</td>
                                            <td className='py-3'>{row?.emp_id}</td>
                                            <td>{row?.name}</td>
                                            <td>{row?.email}</td>
                                            <td>{row?.group?.name}</td>
                                            <td className='!text-center'>
                                                <span style={{backgroundColor: status?.color}} className='px-2 py-1 rounded text-white text-[11px] font-bold'>
                                                    {status?.label}
                                                </span>
                                            </td>
                                            <td>
                                                <div className='flex gap-2 justify-end'>
                                                    <Popover
                                                    showArrow
                                                    backdrop="opaque"
                                                    classNames={{
                                                        base: [
                                                        // arrow color
                                                        "before:bg-default-200",
                                                        ],
                                                        content: [
                                                        "py-3 px-4 border border-default-200",
                                                        "bg-gradient-to-br from-white to-default-300",
                                                        "dark:from-default-100 dark:to-default-50",
                                                        ],
                                                    }}
                                                    placement="top"
                                                    >
                                                        <PopoverTrigger>
                                                            <Button className='bg-green-600' isIconOnly size='sm'>
                                                                <TooltipContainer color='success' content='Lunch Required'>
                                                                    <IconSoup color="white" size="16" />
                                                                </TooltipContainer>
                                                            </Button>
                                                        </PopoverTrigger>
                                                        <PopoverContent>
                                                            {(titleProps) => (
                                                            <div className="px-1 py-2">
                                                                <h3 className="text-small font-bold" {...titleProps}>
                                                                Lunch Confirmation
                                                                </h3>
                                                                <div className="text-tiny">
                                                                    Do you need to add this staff member for lunch today?
                                                                </div>
                                                                <div className="w-full flex mt-2 justify-end">
                                                                    <Button className='bg-green-600 text-white' size='sm' onClick={()=> handleAddLunch(row)}>Confirm</Button>
                                                                </div>
                                                            </div>
                                                            )}
                                                        </PopoverContent>
                                                    </Popover>
                                                    <TooltipContainer content="Status History">
                                                        <Button onClick={()=> handleNavigate(row)} className='bg-purple-600' isIconOnly size='sm'>
                                                            <IconChartHistogram color="white" size="16" />
                                                        </Button>
                                                    </TooltipContainer>
                                                    <ChangePassword entityForm={changePassword} inputFields={changePasswordInput} btnName={'Change Password'} header={'Change Password'} item={row} />
                                                    <DrawerComponent entityForm={update} inputFields={inputUpdateFields} btnName={'Update User'} header={'Update User'} item={row} edit={true} />
                                                    <ConfirmationModal data={row} handle={handleDelete} color="danger" buttonContent="Delete" content={"Are you sure you want to delete this user?"}>
                                                        <IconTrash size="16" />
                                                    </ConfirmationModal>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                )}
                            </tbody>
                        </table>:
                    <Empty />
                }
            </div>
        }

        <PaginationComponent result={result} />

    </div>
  )
}

export default UserList